module.exports = {"home":"Rozcestník","report":"Report","linkages":"Vazby","monitoring":"Monitoring","distraints":"Exekuce","portfolio":"Portfolio"}